import { Navigate } from 'react-router-dom';
import { PATHS, runtimeConfig } from '@/constants';

export const buildNavigatePath = (path: string) => {
	if (!runtimeConfig.isRemoteBuild) {
		return path;
	}
	return `${PATHS.remoteCreatorIndex}/${normalizeRoutePath(path)}`;
};
export const normalizeRoutePath = (path: string) => {
	const normalizedPath =
		path.replace(/\/+/g, '/').replace(/\/$/, '') || PATHS.index;

	if (!runtimeConfig.isRemoteBuild) {
		return normalizedPath;
	}
	return normalizedPath.replace(/^\/creator\/?/, '').replace(/^\//, '');
};

export const homeRoute = {
	path: PATHS.index,
	element: <Navigate to={PATHS.creatorIndex} />
};
